import { useColorModeValue } from '@chakra-ui/react'
import { ResponsivePie } from '@nivo/pie'
import { chartHasMoreThanOne } from 'functions/chartHasMoreThanOne'
import { themeDark, themeLight } from 'theme/charts'
import { defaultColors } from 'theme/charts/default'

interface Props {
    data: any[]
    tooltip?: (args1: any) => React.ReactNode
    customColors?: string[]
    customProps?: any
}

const Donut = ({ data, tooltip, customColors, customProps }: Props) => {
    const theme = useColorModeValue(themeLight, themeDark)

    return (
        <ResponsivePie
            data={data}
            theme={theme}
            tooltip={(values) => tooltip ? tooltip(values) : null}
			margin={{ top: 10, bottom: 40, right: 50, left: 50 }}
            colors={customColors || defaultColors}
            useMesh={true}
			enableArcLabels={true}
            enableArcLinkLabels={false}
            arcLinkLabelsSkipAngle={10}
            arcLinkLabelsTextColor="#FFF"
            arcLinkLabelsThickness={4}
            arcLabelsSkipAngle={20}
            sortByValue={false}
            innerRadius={0.6}
            padAngle={chartHasMoreThanOne(data) ? 2 : 0}
            activeOuterRadiusOffset={6}
            legends={[
                {
                    anchor: "bottom",
                    direction: "row",
                    translateX: 9,
                    translateY: 34,
                    itemWidth: 100,
                    itemHeight: 18,
                    symbolSize: 18,
                    itemDirection: "left-to-right"
                }
            ]}
            fit
            {...customProps}
        />
    )
}

export default Donut